// Check-a-Property mock data

export const SERVICE_PILLARS = [
  {
    id: 'inventories',
    name: 'Property Inventories',
    icon: 'ClipboardList',
    blurb: 'Independent, dispute-ready reports for every stage of the tenancy.',
    options: [
      { id: 'check-in', name: 'Check-In Report', desc: 'Detailed schedule of condition with photos at tenant move-in.', price: 95, duration: '60–90 min' },
      { id: 'mid-term', name: 'Mid-Term Inspection', desc: 'Routine inspection to flag issues during the tenancy.', price: 75, duration: '45–60 min' },
      { id: 'check-out', name: 'Check-Out & Deposit Dispute Report', desc: 'End-of-tenancy comparison with deposit dispute evidence.', price: 110, duration: '60–90 min' },
    ],
  },
  {
    id: 'safety',
    name: 'Safety Certificates',
    icon: 'ShieldCheck',
    blurb: 'Stay compliant with certified safety checks from accredited engineers.',
    options: [
      { id: 'gas-cp12', name: 'Gas Safety CP12', desc: 'Annual landlord gas safety record (CP12).', price: 80, duration: '45 min' },
      { id: 'eicr', name: 'EICR Electrical Report', desc: 'Electrical Installation Condition Report.', price: 150, duration: '2–3 hrs' },
      { id: 'epc', name: 'EPC Energy Performance Certificate', desc: 'Energy rating valid for 10 years.', price: 65, duration: '45–60 min' },
      { id: 'pat', name: 'PAT Testing', desc: 'Portable appliance testing for rented appliances.', price: 60, duration: '30–60 min' },
    ],
  },
  {
    id: 'maintenance',
    name: 'Maintenance Inspections',
    icon: 'Wrench',
    blurb: 'Proactive condition audits that protect your asset and your tenants.',
    options: [
      { id: 'damp-mould', name: 'Damp & Mould Checks', desc: 'Awaab’s Law aligned damp, mould & condensation assessment.', price: 120, duration: '60 min' },
      { id: 'routine-audit', name: 'Routine Maintenance Audits', desc: 'Scheduled property condition and maintenance audit.', price: null, duration: 'Varies' },
      { id: 'roof-gutter', name: 'Roof & Gutter Appraisals', desc: 'External roofline, gutter and drainage appraisal.', price: null, duration: 'Varies' },
    ],
  },
  {
    id: 'specialist',
    name: 'Specialist Property Services',
    icon: 'Sparkles',
    blurb: 'Specialist services to keep properties safe, clean and lettable.',
    options: [
      { id: 'deep-clean', name: 'Deep Cleaning', desc: 'End-of-tenancy professional deep clean.', price: null, duration: 'Varies' },
      { id: 'legionella', name: 'Legionella Risk Assessment', desc: 'Water system legionella risk assessment.', price: 90, duration: '60 min' },
    ],
  },
];

export const ALL_OPTIONS = SERVICE_PILLARS.flatMap((p) => p.options.map((o) => ({ ...o, pillarId: p.id, pillarName: p.name })));
export const findOption = (id) => ALL_OPTIONS.find((o) => o.id === id);

export const PROPERTY_SIZES = ['Studio', '1-bed flat', '2-bed flat', '3-bed flat', '2-bed house', '3-bed house', '4-bed house', '5+ bed house'];

export const ROLES = [
  { id: 'manager', label: 'Landlord / Agent', icon: 'Building2' },
  { id: 'contractor', label: 'Contractor', icon: 'Wrench' },
  { id: 'admin', label: 'Admin', icon: 'ShieldCheck' },
];

export const ROLE_USERS = {
  manager: { name: 'Sarah Mitchell', org: 'Mitchell Lettings' },
  contractor: { name: 'James Carter', org: 'Carter Inspections' },
  admin: { name: 'Admin Team', org: 'Check-a-Property' },
};

export const CONTRACTORS = [
  { id: 'c1', name: 'James Carter', specialism: 'Inventories & Inspections', area: 'Manchester', rating: 4.9, status: 'available' },
  { id: 'c2', name: 'Aisha Khan', specialism: 'Gas & Electrical (CP12, EICR)', area: 'Leeds', rating: 4.8, status: 'available' },
  { id: 'c3', name: 'Tom Wright', specialism: 'EPC & PAT Testing', area: 'London', rating: 4.7, status: 'on-job' },
  { id: 'c4', name: 'Priya Sharma', specialism: 'Damp, Mould & Legionella', area: 'Birmingham', rating: 4.9, status: 'available' },
];

export const STATUS_META = {
  pending: { label: 'Pending', color: 'bg-amber-100 text-amber-800', dot: 'bg-amber-500' },
  in_progress: { label: 'In Progress', color: 'bg-blue-100 text-blue-800', dot: 'bg-blue-500' },
  completed: { label: 'Completed', color: 'bg-emerald-100 text-emerald-800', dot: 'bg-emerald-500' },
};

export const SEED_JOBS = [
  {
    id: 'CAP-2041', optionId: 'check-in', service: 'Check-In Report', pillarName: 'Property Inventories',
    address: '14 Maple Court, Manchester, M14 5TR', size: '2-bed flat', date: '2025-07-18', price: 95,
    status: 'pending', contractor: 'James Carter', client: 'Mitchell Lettings', summary: '', report: false, invoice: false, compliance: [],
  },
  {
    id: 'CAP-2039', optionId: 'eicr', service: 'EICR Electrical Report', pillarName: 'Safety Certificates',
    address: '8 Riverside Apartments, Leeds, LS1 4BR', size: '1-bed flat', date: '2025-07-16', price: 150,
    status: 'in_progress', contractor: 'Aisha Khan', client: 'Mitchell Lettings', summary: '', report: false, invoice: false, compliance: [],
  },
  {
    id: 'CAP-2036', optionId: 'check-out', service: 'Check-Out & Deposit Dispute Report', pillarName: 'Property Inventories',
    address: '120 King Street, Birmingham, B3 1AB', size: '3-bed house', date: '2025-07-09', price: 110,
    status: 'completed', contractor: 'James Carter', client: 'Mitchell Lettings',
    summary: 'Property returned in good overall condition. Minor scuff marks to hallway walls and light wear to carpets consistent with length of tenancy. No deductions recommended beyond standard cleaning.',
    report: true, invoice: true, compliance: ['Check-Out Report', 'Deposit Dispute Evidence Pack'],
  },
  {
    id: 'CAP-2034', optionId: 'gas-cp12', service: 'Gas Safety CP12', pillarName: 'Safety Certificates',
    address: '47 Elm Grove, London, SE15 5DQ', size: '2-bed house', date: '2025-07-05', price: 80,
    status: 'completed', contractor: 'Aisha Khan', client: 'Mitchell Lettings',
    summary: 'All gas appliances tested and safe. Boiler and hob passed. CP12 issued and valid for 12 months.',
    report: true, invoice: true, compliance: ['Gas Safety Record (CP12)'],
  },
  {
    id: 'CAP-2030', optionId: 'epc', service: 'EPC Energy Performance Certificate', pillarName: 'Safety Certificates',
    address: '3 Oakwood Drive, Bristol, BS1 5TR', size: '1-bed flat', date: '2025-07-02', price: 65,
    status: 'completed', contractor: 'Tom Wright', client: 'Mitchell Lettings',
    summary: 'Property assessed at EPC rating C (72). Recommendations: LED lighting and loft insulation top-up to reach band B.',
    report: true, invoice: true, compliance: ['EPC Certificate'],
  },
  {
    id: 'CAP-2028', optionId: 'damp-mould', service: 'Damp & Mould Checks', pillarName: 'Maintenance Inspections',
    address: '22 Beech Road, Liverpool, L8 0SX', size: '2-bed flat', date: '2025-07-21', price: 120,
    status: 'pending', contractor: 'Priya Sharma', client: 'Mitchell Lettings', summary: '', report: false, invoice: false, compliance: [],
  },
  {
    id: 'CAP-2025', optionId: 'mid-term', service: 'Mid-Term Inspection', pillarName: 'Property Inventories',
    address: '9 Victoria Terrace, Sheffield, S1 2GZ', size: '3-bed house', date: '2025-07-15', price: 75,
    status: 'in_progress', contractor: 'James Carter', client: 'Mitchell Lettings', summary: '', report: false, invoice: false, compliance: [],
  },
  {
    id: 'CAP-2019', optionId: 'legionella', service: 'Legionella Risk Assessment', pillarName: 'Specialist Property Services',
    address: '5 Harbour View, Brighton, BN1 1AA', size: 'Studio', date: '2025-06-28', price: 90,
    status: 'completed', contractor: 'Priya Sharma', client: 'Mitchell Lettings',
    summary: 'Low risk. Water systems in regular use, temperatures within safe range. Re-assessment recommended in 24 months.',
    report: true, invoice: true, compliance: ['Legionella Risk Assessment'],
  },
];

export const FRANCHISE_BENEFITS = [
  { icon: 'Layers', title: 'One platform, every supplier', desc: 'Stop jumping between inboxes, spreadsheets and suppliers — manage all property services in one hub.' },
  { icon: 'Map', title: 'Multi-branch management', desc: 'Oversee jobs across regions and teams with role-based access and central reporting.' },
  { icon: 'TrendingUp', title: 'Grow with white-label tools', desc: 'Run inspections under your own brand with our booking, tracking and reporting engine.' },
  { icon: 'FileCheck2', title: 'Audit-ready compliance', desc: 'Every job carries a full audit trail and downloadable compliance documents.' },
];
